import { DocumentStatus } from "~/graphql/supergraphEnums";
import { type GetProfileDetailsQuery } from "~/graphql/supergraphTypes";
import { WITHHOLDING_STATEMENT_SUBTYPE } from "~/pages/Compliance/CaseDetailsDrawer/Documents/DocumentManagement/DocumentDetailsRightSidebar/DocumentDetailsFormValues/WSeriesTaxDocFormValues/constants";
import {
  TAX_DOCUMENT_BASE_TYPES,
  getSecondaryDocumentType,
} from "~/pages/Compliance/CaseDetailsDrawer/Documents/TaxForms";

type ProfileDocument = NonNullable<
  GetProfileDetailsQuery["complianceProfile"]
>["documents"][number];

export const filterTaxDocuments = (documents: ProfileDocument[]): ProfileDocument[] => {
  return documents.filter((doc) => {
    const isTaxDocument = TAX_DOCUMENT_BASE_TYPES.includes(
      doc.documentPurpose?.baseType as (typeof TAX_DOCUMENT_BASE_TYPES)[number],
    );
    const subType = getSecondaryDocumentType(doc.metadata);
    const hasValidSubType = subType !== undefined && subType !== "";
    const isWithholdingStatement = subType === WITHHOLDING_STATEMENT_SUBTYPE;
    return isTaxDocument && hasValidSubType && !isWithholdingStatement;
  });
};

export const getDocumentStatus = (status: string | null | undefined): DocumentStatus => {
  if (status === DocumentStatus.Verified) return DocumentStatus.Verified;
  if (status === DocumentStatus.Invalid) return DocumentStatus.Invalid;
  return DocumentStatus.New;
};
